//src/config.js
const REGION_API_URLS = {
  IN: "https://api.thurent.in/api/",
  INDIA: "https://api.thurent.in/api/",
  US: "https://backend.thurent.us/api/",
  USA: "https://backend.thurent.us/api/",
};

const apiRegion = (process.env.REACT_APP_API_REGION || "IN").toUpperCase();
const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL ||
  REGION_API_URLS[apiRegion] ||
  REGION_API_URLS.US
).replace(/\/$/, "");


const isIndia = ["IN", "INDIA"].includes(apiRegion);

const config = {
  companyName: "Thurent",
  //isIndia: apiRegion.startsWith("US"),
  isIndia: isIndia,
  eventLocalStorageKey: "createEventFormSession",
  eventEditLocalStorageKey: "editEventFormSession",
  providerListStorageKey: "providerListSession",
  cartItemKey: "cartItemSession",

  //API_BASE_URL,
  // "http://localhost:3001/api",
  // "https://backend.thurent.us/api";
  // "https://api.thurent.in/api",
  // "https://api.dev.thurent.in/api",
  // API_BASE_URL: 'http://localhost:3001/api',
  // Add other configurations if needed
  API_BASE_URL,

  // Invitations are React routes hosted on the frontend, not the API server.
  INVITATION_URL: `${window.location.origin}/invitation`,
  token:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTcyNTU2NTc2MCwiZXhwIjoxNzI1NTY5MzYwfQ.yHdfylPCyDVYm_8aSEpoC_Yc5YOF-z4__diuPB_C1mQ",


  companyFullName: isIndia
    ? "THURENT TECH SERVICES PRIVATE LIMITED"
    : "Thurent LLC",


  // Contact Information by Region
  contactInfo: {
    india: {
      companyName: "THURENT TECH SERVICES PRIVATE LIMITED",
      name: "Nagesh Kondoori (Nick) ",
      title: "Founder and CTO ",
      email: "nick@thurent.in",
      phone: "+91 74167-34499",
      address: "T-Hub\nPhase II Gachibowli,\nHYDERABAD Telangana",
    },
    usa: {
      companyName: "Thurent LLC",
      name: "Armstead Rasheed King III",
      title: "Co-Founder & CEO",
      email: "Armstead@thurent.us",
      // phone: "+1 682-XXX-XXXX",
      address: "Manfield, TX",
    },
  },
};


export default config;
